import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Crypto from './Crypto';
import Documentation from './Documentation';
import DefaultPages from './DefaultPages';
import Account from './Account';
import ECommerce from './ECommerce';
import Maps from './Maps';
import Charts from './Charts';
import Tables from './Tables';
import Forms from './Forms';
import UI from './UI';

import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';

import FitnessDashboard from '../../../Dashboards/Fitness/index';
import DefaultDashboard from '../../../Dashboards/Default/index';
import MobileAppDashboard from '../../../Dashboards/MobileApp/index';
import BookingDashboard from '../../../Dashboards/Booking/index';

import Mail from '../../../Mail/index';
import Target from './Target';
import Customers from './Customers';
import Blasts from './Blasts';


import BlackList from './BlackList';
import Bets from './Bets';
import Reports from './Reports';
import Finance from './Finance';
import users from './users';
import { FAQs } from '../../../FAQs/faq';
import { CustomersWithdrwals } from '../../../Finance/customerwithdraws';
import { Transaction } from '../../../Finance/transaction';

import { reversal } from '../../../Finance/reversal.jsx';

import { DepositRequests } from '../../../Finance/depositrequests';
import { activeDepositors } from '../../../Blasts/activeDepositors';
import { MPESASeach } from '../../../users/mpesareversal';
import { BlastCountPlayed } from '../../../Blasts/countPlayed';

import { sendSMSBalance } from '../../../Blasts/sendSMSBalance';

import { neverDepositors } from '../../../Blasts/neverDepositors';

import {BlastedMessages} from '../../../Blasts/getblasted_messages';
import { CustomerFeedBacks } from '../../../Reports/customerfeedbacks';
import { OutCustomerFeedBacks } from '../../../Reports/outcustomerfeedbacks';


export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/dashboard_default" component={DefaultDashboard} />
      <Route path="/dashboard_e_commerce" component={Commerce} />
      <Route path="/dashboard_fitness" component={FitnessDashboard} />
      <Route path="/dashboard_crypto" component={Crypto} />
      <Route exact path="/dashboard_mobile_app" component={MobileAppDashboard} />
      <Route path="/dashboard_booking" component={BookingDashboard} />
      <Route path="/ui" component={UI} />
      <Route path="/target" component={Target} />
      <Route path="/termscon" component={FAQs} />
      <Route path="/mail" component={Mail} />
      <Route path="/chat" component={Chat} />
      <Route path="/todo" component={Todo} />
      <Route path="/forms" component={Forms} />
      <Route path="/tables" component={Tables} />
      <Route path="/charts" component={Charts} />
      <Route path="/maps" component={Maps} />
      <Route path="/account" component={Account} />
      <Route path="/customers" component={Customers} />
      <Route path="/customers-withdrawals" component={CustomersWithdrwals} />
      <Route path="/transaction" component={Transaction} />
      <Route path="/DepositRequests" component={DepositRequests} />

      <Route path="/blasts" component={Blasts} />
      
      <Route path="/countplays" component={BlastCountPlayed} />
      
      <Route path="/activeDepositors" component={activeDepositors} />

      <Route path="/reverse" component={MPESASeach} />
      
      <Route path="/reversals" component={reversal} />

      <Route path="/balance_blast" component={sendSMSBalance} />

      <Route path="/never_deposited" component={neverDepositors} />
      
      <Route path="/blasted_messages" component={BlastedMessages} />

      <Route path="/incoming_feed" component={CustomerFeedBacks} />

      <Route path="/outgoing_feed" component={OutCustomerFeedBacks} />


      <Route path="/" component={BlackList} />
      <Route path="/" component={Bets} />
      <Route path="/" component={Reports} />
      <Route path="/" component={Finance} />
      <Route path="/" component={users} />
      <Route path="/e-commerce" component={ECommerce} />
      <Route path="/default_pages" component={DefaultPages} />
      <Route path="/documentation" component={Documentation} />
    </div>
  </div>
);
